export const PAGINATION_SIZE = 5 // number of displayed numbers
export const BASE_URL = process.env.GATSBY_STAGE !== 'production' ? 'http://localhost:5050' : 'https://mynatime-api.netlify.app/.netlify/functions/api'
export const LIKE_TYPES = {
  BLOG: 0,
  WORK: 1,
  SHOP: 2
}
